import React from 'react'

const HelpIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`transition-colors duration-200 ${className}`}
      {...props}
    >
      <path 
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M10.125 8.87499C10.125 8.54663 10.2113 8.22404 10.3752 7.9395C10.5391 7.65495 10.7748 7.41843 11.0588 7.2536C11.3428 7.08877 11.6651 7.00141 11.9934 7.00026C12.3218 6.9991 12.6447 7.0842 12.9298 7.24704C13.215 7.40988 13.4523 7.64474 13.6182 7.92813C13.7841 8.21152 13.8726 8.5335 13.875 8.86185C13.8773 9.1902 13.7934 9.51341 13.6316 9.79914C13.4698 10.0849 13.2358 10.3231 12.953 10.49C12.478 10.771 12 11.198 12 11.75V13" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
      <path 
        d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" 
        fill="currentColor"
      />
    </svg>
  )
}

export default HelpIcon
